<span class="video-text relative inline-block align-middle"
  [style.width]="dimensions.width ? dimensions.width + 'px' : 'auto'"
  [style.height]="dimensions.height ? dimensions.height + 'px' : 'auto'">

  <!-- 隐藏的文本用于SEO -->
  <span class="sr-only">
    {{ncText}}
  </span>

  <!-- 视觉占位符 -->
  <span #textContent style="opacity: 0;display: inline-block; white-space: nowrap;"
    [style.position]="isReady ? 'absolute' : 'relative'" aria-hidden="true">
    {{ncText}}
  </span>

  <div class="absolute inset-0" [style.opacity]="isReady ? 1 : 0" style="transition: opacity 0.2s ease-in;"
    aria-hidden="true">

    <svg [attr.width]="dimensions.width" [attr.height]="dimensions.height" class="absolute inset-0">
      <defs>
        <clipPath [attr.id]="maskId">
          <text #svgText x="50%" y="50%" dominant-baseline="middle" text-anchor="middle"
            [attr.style]="getStyleString()">{{ncText}}</text>
        </clipPath>
      </defs>
    </svg>

    <video class="w-full h-full object-cover" preload="auto" autoPlay muted loop [style.clip-path]="'url(#' + maskId + ')'"
      [style.-webkit-clip-path]="'url(#' + maskId + ')'">
      <source [src]="ncSrc">
      您的浏览器不支持视频标签。
    </video>
  </div>
</span>